import React, { useContext } from 'react';
import Modal from '../../../../../main/components/Modal';
import Table from '../../../../components/Table';
import GlobalContext from '../../../../../main/utils/GlobalContext';

export const columns = (locales) => [
  {
    title: locales.admin.project,
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: locales.admin.activityTotal,
    dataIndex: 'sumTimeTracks',
    key: 'sumTimeTracks',
    render: (projectsTimeTracks) => projectsTimeTracks || 0,
  },
  {
    title: locales.admin.last30Days,
    dataIndex: 'sumLastTimeTracks',
    key: 'sumLastTimeTracks',
    render: (projectsLastTimeTracks) => projectsLastTimeTracks || 0,
  },
];

const ModalBMCList = ({
  visible,
  onClose,
  fetchClassroomBMCs,
  bmcId,
  bmcs,
  loading = false,
  sort,
  meta,
  rowClick,
  rowClickable = false,
}) => {
  const { locales } = useContext(GlobalContext);

  return (
    <Modal
      size="sm"
      isOpen={visible}
      title={locales.admin.projectsInTheClass}
      onClose={onClose}
    >
      <div className="team-members-modal">
        <Table
          columns={columns(locales)}
          dataSource={bmcs}
          loading={loading}
          total={meta?.count || 0}
          current={meta?.page || 1}
          onChange={(pagination) => {
            const { current, pageSize } = pagination;
            fetchClassroomBMCs({
              bmcId,
              page: current,
              limit: pageSize,
            });
          }}
          onRow={(record) => ({ onClick: () => rowClick(record) })}
          rowClickable={rowClickable}
          onSort={sort}
          meta={meta}
        />
      </div>
    </Modal>
  );
};

export default ModalBMCList;
